import api from './api'
import { API_ENDPOINTS } from '../config/api'

const fixturesService = {
  // skipLoader: the header polls this in the background
  get: async () => {
    const response = await api.get(API_ENDPOINTS.FIXTURES, { skipLoader: true })
    return response.data
  },
}

export default fixturesService
